import script from "./PublishersTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PublishersTab.vue?vue&type=script&setup=true&lang=js"

import "./PublishersTab.vue?vue&type=style&index=0&id=60b5a9fc&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60b5a9fc"]])

export default __exports__